export const PII_BADGE_CLASSES =
  "border-[#FEDF89] bg-[#FFFAEB] text-[#F79009] dark:bg-[#551C10] dark:border-[#932F19] dark:text-[#EF6820] dark:hover:bg-[#551C10]";
